<template>
    <ValidationObserver ref="observer">
        <div class="row mb-5">
            <div class="col-12">
                <label class="mb-4 h4 text-uppercase">Resumen de compra</label>
                <div class="padding-content">
                    <ResumenCompraComponent :base="base" :items="[base.categoria_base]" :indumentariasElegidas="base.indumentariasElegidas"/>
                    <div class="form-group">
                        <label for="metodo_pago">Método de pago</label>
                        <ValidationProvider name="metodo_pago" rules="required" v-slot="{ errors }">
                            <select :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" name="metodo_pago" id="metodo_pago" v-model="base.metodo_pago">
                                <template v-for="(metodo, index) in metodos_pago">
                                    <option :key="index" :value="metodo.id">{{ metodo.nombre }}</option>
                                </template>
                            </select>
                        </ValidationProvider>
                    </div>
                </div>
                <div class="mt-3">
                    <div id="formulario-compra" v-html="formulario"></div>
                    <div v-if="show == true" class="mt-4">
                        <button type="submit" name="button" id="terminar" class="button effect-button large-button" @click="submit()">
                            <span>Terminar</span>
                        </button>
                    </div>
                    <div v-if="!loading">
                        <div class="col-12 mt-3" v-if="compra_finalizada">
                            <div class="alert alert-success alert-dismissible">
                                <h5><i class="icon fas fa-check"></i>¡Compra finalizada correctamente!</h5>
                                <template>
                                    <Button @click="$router.push({ name: 'back.bases.index' })">Volver al listado de bases</Button>
                                </template>
                            </div>
                        </div>
                        <div v-if="errors.length > 0">
                            <div class="alert alert-danger alert-dismissible">
                                <h5><i class="icon fas fa-ban"></i>Ha ocurrido un error</h5>
                                <template>
                                    <Button @click="$router.push({ name: 'back.bases.index' })">Volver al listado de bases</Button>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <LoaderComponent></LoaderComponent>
                    </div>
                </div>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
import ResumenCompraComponent from "./ResumenCompraComponent";

export default {
    props: ["base", "items"],
    data() {
        return {
            loading: false,
            formulario: null,
            show: true,
            compra_finalizada: false,
            errors: [],
        };
    },
    computed: {
        metodos_pago() {
            return this.teatro.metodos_pago_abonos_bases.filter(metodo_pago => metodo_pago.show_taquilla == 1);
        },
        configuracion() {
            return this.$store.getters.getConfig;
        },
        lista_abonados() {
            return this.$store.getters.getListaAbonados;
        },
        teatro() {
            return this.$store.getters.getTeatro;
        }
    },
    methods: {
        async submit() {
            const isValid = await this.$refs.observer.validate();
            if (isValid) {
                this.cargarFormularioPago();
                (this.show = false), this.$emit("terminado");
            }
        },
        atras() {
            this.$emit('volver');
        },
        guardarDatosComprador() {
            let params = {
                base: this.base,
                filters: {
                    tid: this.configuracion.hash_teatro
                }
            }

            this.$store.dispatch(this.config.getVuexAlias('front.bases.guardar-datos-deportista'), params).then(res => {});
        },
        cargarFormularioPago() {
            this.loading = true;
            
            let path = this.$router.resolve({ name: "back.bases.crear" }).href;
            let fullUrlSuccess = window.location.origin + path + "?error=no";
            let fullUrlFailure = window.location.origin + path + "?error=si";
            this.base["filters"] = {
                tid: this.configuracion.hash_teatro,
            };
            this.base["url_success"] = fullUrlSuccess;
            this.base["url_failure"] = fullUrlFailure;
            this.base["tid"] = this.configuracion.hash_teatro;
            this.base["lista_abonado_id"] = this.lista_abonados.id;

            this.guardarDatosComprador();

            setTimeout(() => {
                this.$store.dispatch(
                    this.config.getVuexAlias("back.bases.crear"), this.base).then(res => {
                    this.formulario = res.data.formulario;
                    this.compra_finalizada = true;
                }).catch(error => {
                    this.compra_finalizada = false;
                    this.errors = error.response.data;
                }).finally(() => {
                    this.loading = false;
                });
            }, 1000);
        },
        borrarMetodoDePago(metodos_de_pago, id) {
            const metodo_pago_id = metodos_de_pago.findIndex(metodo_de_pago => metodo_de_pago.id === id);
            metodos_de_pago.splice(metodo_pago_id, 1);
            return metodos_de_pago;
        }
    },
    components: {
        ResumenCompraComponent
    },
};
</script>